/**
 * useScreenReady を入れたルート（normalizeScreenPathname 後の pathname）。
 * 未掲載の画面は最初の描画（T1）で first_paint として確定する。
 * Template に useScreenReady を足したら必ずここにも足す（漏れると T1 で確定して値が小さく出る）。
 */
export const SCREEN_READY_ROUTES: readonly RegExp[] = [
  /^\/discover$/,
  /^\/recommend$/,
  /^\/discover\/section\/[^/]+$/,
  /^\/live$/,
  /^\/messages$/,
  /^\/messages\/[^/]+$/,
  /^\/profile\/[^/]+$/,
  /^\/board$/,
  /^\/search\/result$/,
  /^\/my-page$/,
  /^\/my-page\/bookmarks$/,
  // ready は UserProfileTemplate 経由（LiveBroadcasterProfileTemplate が内包）
  /^\/profile\/live-broadcaster\/[^/]+$/,
  /^\/daily-bonus$/,
  /^\/search$/,
  /^\/call\/video\/outgoing$/,
  /^\/call\/video$/,
  /^\/onboarding$/,
  /^\/purchase$/,
];

export const isScreenReadyRoute = (pathname: string): boolean =>
  SCREEN_READY_ROUTES.some((pattern) => pattern.test(pathname));
